import { useEffect } from "react";
import { useParams } from "react-router";
import Loader from "../../components/atoms/Loader";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsPage from "../../hocs/enhanceSectionsPage";
import OperatorInterface from "../../interfaces/OperatorInterface";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionStaffBoardPostEdit from "./SectionStaffBoardPostEdit";

interface Props extends OutletContextProps {
  currentOperator: OperatorInterface | undefined;
  section: SectionInterface;
}

const SectionStaffBoardPostPage = (props: Props) => {
  const { setActiveMenu, section, currentOperator } = props;

  useEffect(() => {
    setActiveMenu("dashboard");
  }, []);

  const params = useParams<{ staffBoardPostId: string }>();

  if (!params.staffBoardPostId || !currentOperator) {
    return <Loader loading />;
  }

  return (
    <SectionStaffBoardPostEdit
      section={section}
      currentOperator={currentOperator}
      staffBoardPostId={params.staffBoardPostId}
    />
  );
};

const pageInfo = {
  title: "スタッフボード",
};

export default enhanceSectionsPage(SectionStaffBoardPostPage, pageInfo);
